import { type HTMLAttributes } from 'react';

type Variant = 'default' | 'positive' | 'warning' | 'info' | 'destructive';

const variants: Record<Variant, string> = {
  default: 'bg-muted text-muted-foreground',
  positive: 'bg-positive-subtle text-positive-foreground',
  warning: 'bg-warning-subtle text-warning-foreground',
  info: 'bg-info-subtle text-info-foreground',
  destructive: 'bg-destructive/10 text-destructive',
};

const base = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
}

export function Badge({ variant = 'default', className = '', ...props }: BadgeProps) {
  return (
    <span className={`${base} ${variants[variant]} ${className}`} {...props} />
  );
}
